import React from "react";

const UsersPage = () => {
  return <div>UsersPage</div>;
};

export default UsersPage;
